import { create } from 'zustand'
import { devtools, persist } from 'zustand/middleware'

type Updater<T> = (state: T) => T | Partial<T>
type StateOrUpdater<T> = T | Partial<T> | Updater<T>
export type SetFunction<T> = (
  stateOrUpdater: StateOrUpdater<T>,
  replace?: boolean,
) => void

export type StoreConfig<T> = (set: SetFunction<T>, get: () => T) => T

export function createStore<T>(
  config: StoreConfig<T>,
  options?: { name?: string },
) {
  const isClient = typeof window !== 'undefined'

  if (isClient && options?.name) {
    const storeWithMiddlewares = persist(
      devtools(config, { name: options.name }),
      {
        name: options.name,
      },
    )

    return create<T>()(storeWithMiddlewares)
  } else {
    return create<T>()(config)
  }
}
